import firebase from 'firebase/app';
export class ImpressionLog {
  adUrl: string;
  bookingId: string;
  id: string;
  lat: number;
  long: number;
  timestamp: firebase.firestore.Timestamp;
  fileType: string;

  constructor(
    adUrl?: string,
    bookingId?: string,
    id?: string,
    lat?: number,
    long?: number,
    _timestamp?: firebase.firestore.Timestamp,
    fileType?: string
  ) {
    this.adUrl = adUrl;
    this.bookingId = bookingId;
    this.id = id;
    this.lat = lat || null;
    this.long = long || null;
    this.timestamp = firebase.firestore.Timestamp.now();
    this.fileType = fileType;
  }
}
